/******/ (() => { // webpackBootstrap
/*!*********************************************!*\
  !*** ./src/js/components/BundleItemCard.js ***!
  \*********************************************/
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _wrapNativeSuper(t) { var r = "function" == typeof Map ? new Map() : void 0; return _wrapNativeSuper = function _wrapNativeSuper(t) { if (null === t || !_isNativeFunction(t)) return t; if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function"); if (void 0 !== r) { if (r.has(t)) return r.get(t); r.set(t, Wrapper); } function Wrapper() { return _construct(t, arguments, _getPrototypeOf(this).constructor); } return Wrapper.prototype = Object.create(t.prototype, { constructor: { value: Wrapper, enumerable: !1, writable: !0, configurable: !0 } }), _setPrototypeOf(Wrapper, t); }, _wrapNativeSuper(t); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(t) { try { return -1 !== Function.toString.call(t).indexOf("[native code]"); } catch (n) { return "function" == typeof t; } }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
var handleize = function handleize(str) {
  return str.replace(/[\s/]+/g, '-') // Replace spaces and slashes with hyphens
  .toLowerCase();
};
var BundleItemCard = /*#__PURE__*/function (_HTMLElement) {
  function BundleItemCard() {
    var _JSON$parse;
    var _this;
    _classCallCheck(this, BundleItemCard);
    _this = _callSuper(this, BundleItemCard);
    _this.colorSwatchesRadios = null;
    _this.sizeSwatchesRadios = null;
    _this.selectedColorIndicators = null;
    _this.selectedSizeIndicators = null;
    _this.image = null;
    _this.imageCache = new Map();
    _this.itemData = JSON.parse(_this.querySelector('[data-bundle-item-json]').textContent);
    _this.itemVarients = ((_JSON$parse = JSON.parse(document.querySelector('#bundleJson').textContent)) === null || _JSON$parse === void 0 ? void 0 : _JSON$parse.variants) || [];
    return _this;
  }
  _inherits(BundleItemCard, _HTMLElement);
  return _createClass(BundleItemCard, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.setupElements();
      this.initialize();
    }
  }, {
    key: "setupElements",
    value: function setupElements() {
      this.colorSwatchesRadios = this.querySelectorAll('[data-colour-radio]');
      this.sizeSwatchesRadios = this.querySelectorAll('[data-size-radio]');
      this.selectedColorIndicators = this.querySelectorAll('[data-colour-selected]');
      this.selectedSizeIndicators = this.querySelectorAll('[data-size-selected]');
      this.imageWrapper = this.querySelector('[data-image-wrapper]');
      this.image = this.querySelector('[data-image-wrapper] img');
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;
      this.colorSwatchesRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          _this2.handleColorChange(e.target.value);
        });
      });
      this.sizeSwatchesRadios.forEach(function (radio) {
        radio.addEventListener('change', function (e) {
          _this2.handleSizeChange(e.target.value);
        });
      });
      this.addEventListener('change', this.handleSelectionChange);
      this.handleSelectionChange();
    }

    /**
     * Handles the recalculation and display of total and compare-at prices for a product bundle.
     * This function is triggered when there's a change in product variants or quantity.
    */
  }, {
    key: "handlePriceChange",
    value: function handlePriceChange() {
      var _this3 = this;
      // Cache the quantity input element to avoid requerying the DOM.
      var quantityInput = document.querySelector('[data-quantity-input][name="quantity"]');
      var quantity = parseInt(quantityInput.value, 10) || 1; // Default to 1 if not a valid number.

      // Get all bundle item elements. Caching this avoids requerying in a loop.
      var bundleItems = document.querySelectorAll("bundle-item-card.bundle-product-panel");

      // Use Array.prototype.reduce for a more functional and concise way to calculate totals.
      var _Array$from$reduce = Array.from(bundleItems).reduce(function (totals, item) {
          var _item$querySelector$i, _item$querySelector, _item$querySelector$i2, _item$querySelector2, _parseInt, _item$querySelector3;
          var productId = item.getAttribute("data-product-id");

          // Construct the variant option strings.
          // Using optional chaining (?.) and nullish coalescing (??) for safer access and cleaner code.
          var color = (_item$querySelector$i = (_item$querySelector = item.querySelector('.item-variant-color')) === null || _item$querySelector === void 0 ? void 0 : _item$querySelector.innerHTML) !== null && _item$querySelector$i !== void 0 ? _item$querySelector$i : '';
          var size = (_item$querySelector$i2 = (_item$querySelector2 = item.querySelector('.item-variant-size')) === null || _item$querySelector2 === void 0 ? void 0 : _item$querySelector2.innerHTML) !== null && _item$querySelector$i2 !== void 0 ? _item$querySelector$i2 : '';
          var stepQuantity = (_parseInt = parseInt((_item$querySelector3 = item.querySelector('.item-step-quantity')) === null || _item$querySelector3 === void 0 ? void 0 : _item$querySelector3.innerHTML)) !== null && _parseInt !== void 0 ? _parseInt : 1;
          var strFindColour = "Colour: ".concat(color);
          var strFindColor = "Color: ".concat(color);
          var strFindSize = "Size: ".concat(size);

          // Proceed only if there are variants to check against.
          if (_this3.itemVarients && _this3.itemVarients.length) {
            // Find the matching variant for the current bundle item.
            // Using .find() is more efficient than .filter() when you only expect one result.

            //         ye har variant match karne ke liye dono chiz check kar raha hai (color bhi, size bhi).
            // Agar variant ke paas size option hi nahi hai, to variantSize = undefined hoga, aur condition kabhi true nahi hogi.

            // const matchedVariant = this.itemVarients.find(variant => {
            //   // Ensure the product ID matches.
            //   if (variant.product_id != productId) {
            //     return false;
            //   }
            //   // Check if the variant options match the selected color and size.
            //   const [variantColor, variantSize] = variant.options || [];
            //   return (variantColor === strFindColour || variantColor === strFindColor) && variantSize === strFindSize;
            // });

            //Agar product ke variants me sirf color hoga → sirf color match hoga.  // Agar color + size hoga → dono check honge.
            var matchedVariant = _this3.itemVarients.find(function (variant) {
              if (variant.product_id != productId) return false;
              var _ref = variant.options || [],
                _ref2 = _slicedToArray(_ref, 2),
                variantColor = _ref2[0],
                variantSize = _ref2[1];

              // Agar product ke variant me size option hai, tabhi check karo
              if (variantSize !== undefined && strFindSize) {
                return (variantColor === strFindColour || variantColor === strFindColor) && variantSize === strFindSize;
              }

              // Agar sirf color based hai
              return variantColor === strFindColour || variantColor === strFindColor;
            });

            // ✅ Debug each matchedVariant
            // console.log("=== DEBUG ITEM ===");
            // console.log("Product ID:", productId);
            // console.log("Selected color:", color, " | size:", size);
            // console.log("Matched Variant:", matchedVariant);
            // console.log("Variant price (cents):", matchedVariant?.price);
            // console.log("Variant compare_at_price (cents):", matchedVariant?.compare_at_price);

            // If a matching variant is found, add its price to the totals.
            if (matchedVariant) {
              totals.totalCompareAtPrice += matchedVariant.compare_at_price * 1 * stepQuantity || 0;
              totals.totalPrice += matchedVariant.price * 1 * stepQuantity || 0;
            }
          }
          return totals;
        }, {
          totalPrice: 0,
          totalCompareAtPrice: 0
        }),
        totalPrice = _Array$from$reduce.totalPrice,
        totalCompareAtPrice = _Array$from$reduce.totalCompareAtPrice; // Initial values for the reducer.

      // Update input for single Compare & total pricing
      document.getElementById("bundleTotalPrice").value = totalPrice;
      document.getElementById("bundleCompareTotalPrice").value = totalCompareAtPrice;

      // Calculate the final prices based on the selected quantity.
      var finalTotalPrice = totalPrice * quantity;
      var finalTotalCompareAtPrice = totalCompareAtPrice * quantity;
      //calculate disocunt if any avaliable in bundle 
      var bundleJsonDiscount = document.querySelector('#bundleJson');
      if (bundleJsonDiscount) {
        var _bundleDataParse$bund;
        var bundleDataParse = JSON.parse(bundleJsonDiscount.textContent);

        // Retrive the bundle data separately
        bundleDataFinalDiscount = bundleDataParse.bundleData;

        //  search for the disocunt if any then apply
        var discountPercent = ((_bundleDataParse$bund = bundleDataParse.bundleData) === null || _bundleDataParse$bund === void 0 ? void 0 : _bundleDataParse$bund.bundleDiscount) || 0;
        if (discountPercent > 0) {
          finalTotalPrice = finalTotalPrice - finalTotalPrice * discountPercent / 100;
        }
      }

      // Format the prices to two decimal places.
      var formattedTotalPrice = (finalTotalPrice / 100.00).toFixed(2);
      var formattedCompareAtPrice = (finalTotalCompareAtPrice / 100.00).toFixed(2);

      // Update all elements displaying the total price.
      // Using a for...of loop for cleaner iteration.
      var priceElements = document.querySelectorAll(".bundle-total-price-js");
      var _iterator = _createForOfIteratorHelper(priceElements),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var el = _step.value;
          el.innerHTML = formattedTotalPrice;
        }

        // Update all elements displaying the compare-at price.
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      var comparePriceElements = document.querySelectorAll(".bundle-compare-price-js");
      var _iterator2 = _createForOfIteratorHelper(comparePriceElements),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _el = _step2.value;
          _el.innerHTML = formattedCompareAtPrice;
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      document.querySelector(".quick-add-mob-product-price").innerHTML = document.querySelector(".bundleprice").innerHTML;
    }
  }, {
    key: "handleSelectionChange",
    value: function handleSelectionChange() {
      var hasOnlyOneOption = this.colorSwatchesRadios.length === 0 && this.sizeSwatchesRadios.length === 0;
      // console.log('hasOnlyOneOption', hasOnlyOneOption)
      var checkedOption = Boolean(this.querySelector('[data-colour-radio]:checked')) || Boolean(this.querySelector('[data-size-radio]:checked')) || hasOnlyOneOption;
      // console.log('checkedOption', checkedOption)
      this.dataset.hasSelection = checkedOption ? 'true' : 'false';
      this.handlePriceChange();
    }
  }, {
    key: "handleColorChange",
    value: function handleColorChange(color) {
      this.selectedColorIndicators.forEach(function (indicator) {
        indicator.textContent = color;
      });
      this.dataset.productUrl = this.dataset.productUrl.replace(/c:([^,]*)/, "c:".concat(encodeURIComponent(handleize(color))));
      if (this.image) void this.fetchImage(color);
    }
  }, {
    key: "handleSizeChange",
    value: function handleSizeChange(size) {
      this.selectedSizeIndicators.forEach(function (indicator) {
        indicator.textContent = size;
      });
      this.dataset.productUrl = this.dataset.productUrl.replace(/s:([^,]*)/, "s:".concat(encodeURIComponent(handleize(size))));
      if (this.image) void this.fetchImage(size);
    }
  }, {
    key: "getVariantId",
    value: function getVariantId(color) {
      var _this$itemData;
      return (_this$itemData = this.itemData) === null || _this$itemData === void 0 || (_this$itemData = _this$itemData.variants) === null || _this$itemData === void 0 || (_this$itemData = _this$itemData.find(function (variant) {
        var titleArr = variant.title.split('/');
        return titleArr[0].trim().toLowerCase() === color.toLowerCase();
      })) === null || _this$itemData === void 0 ? void 0 : _this$itemData.id.match(/(\d+)$/)[1];
    }
  }, {
    key: "fetchImage",
    value: function () {
      var _fetchImage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(color) {
        var spinner, fetchTemplate, fetchUrl, _this$getVariantId, lazyimg, _this$getVariantId2, response, text, parser, docParsed, newImageHTML, _lazyimg, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              spinner = this.querySelector('.loading-overlay__spinner');
              fetchTemplate = 'card-images-bundle';
              fetchUrl = "".concat(this.dataset.productUrl, "?view=").concat(fetchTemplate);
              if (!this.imageCache.has(fetchUrl)) {
                _context.n = 1;
                break;
              }
              // console.log('Using cached image');
              this.imageWrapper.innerHTML = this.imageCache.get(fetchUrl);
              this.updateVariantId((_this$getVariantId = this.getVariantId(color)) !== null && _this$getVariantId !== void 0 ? _this$getVariantId : this.imageWrapper.querySelector('[data-variant-id]').dataset.variantId);
              // console.log('variantId', this.getVariantId(color));
              // console.log('this.imageWrapper', this.imageWrapper.querySelector('[data-variant-id]').dataset.variantId);

              this.setupElements();

              // lazy load images
              lazyimg = new Event('lazyimg');
              window.dispatchEvent(lazyimg);
              return _context.a(2);
            case 1:
              if (spinner) spinner.classList.remove('hidden');
              _context.p = 2;
              _context.n = 3;
              return fetch(fetchUrl);
            case 3:
              response = _context.v;
              if (response.ok) {
                _context.n = 4;
                break;
              }
              throw new Error('Failed to fetch image');
            case 4:
              _context.n = 5;
              return response.text();
            case 5:
              text = _context.v;
              parser = new DOMParser();
              docParsed = parser.parseFromString(text, 'text/html');
              newImageHTML = docParsed.querySelector('.product-images').innerHTML;
              this.imageWrapper.innerHTML = newImageHTML;
              this.updateVariantId((_this$getVariantId2 = this.getVariantId(color)) !== null && _this$getVariantId2 !== void 0 ? _this$getVariantId2 : docParsed.querySelector('[data-variant-id]').dataset.variantId);
              // save to cache
              this.imageCache.set(fetchUrl, newImageHTML);
              if (spinner) spinner.classList.add('hidden');
              this.setupElements();

              // lazy load images
              _lazyimg = new Event('lazyimg');
              window.dispatchEvent(_lazyimg);
              _context.n = 7;
              break;
            case 6:
              _context.p = 6;
              _t = _context.v;
              console.error(_t);
              if (spinner) spinner.classList.add('hidden');
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[2, 6]]);
      }));
      function fetchImage(_x) {
        return _fetchImage.apply(this, arguments);
      }
      return fetchImage;
    }()
  }, {
    key: "updateVariantId",
    value: function updateVariantId(variantId) {
      this.dataset.variantId = String(variantId);
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get('bundle-item-card')) {
  customElements.define('bundle-item-card', BundleItemCard);
}
/******/ })()
;